import Recorder from 'recorder-js';

window.training = (params) => {
    let retryCount = 0;
    const maxRetries = 1;

    let isDialog = params.isDialog;
    let recorder;
    let audioContext, analyser, microphone;
    let silenceTimeout;
    let isRecording = false;
    let isTracking = false;
    let socket;
    let recordingInterval;
    let text = '';

    // Initialize event listeners for buttons
    const init = () => {

        if (isDialog) {
            $('#start-training').text('Продолжить тренировку')
            $('#save-training').show()
            $('#save-start-training').show()
        }

        $('#start-training').on('click', () => handleStartTraining());

        $('#stop-training').on('click', () => handleStopTraining());

        $('#save-training').on('click', () => handleSaveTraining())

        $('#save-start-training').on('click', () => handleSaveStartTraining())

        $(window).on('beforeunload', () => {
            if (isDialog) {
                return 'Вы точно хотите покинуть страницу? результат тренировки будет потерян';
            }
        })
    };

    // Initialize WebSocket connection
    const initSocket = () => {
        socket = new WebSocket(process.env.MIX_RATCHET_URL);

        socket.onopen = () => {
            console.log('WebSocket соединение установлено');
            $('#loader').text('Говорите');
        };

        socket.onmessage = (event) => {
            console.log(event.data);
            text += event.data + ' ';
        };

        socket.onerror = (error) => {
            console.error('Ошибка WebSocket', error);
            if (isRecording) {
                isTracking = true;
            }
        };

        socket.onclose = (event) => {
            if (!event.wasClean) {
                console.warn('Соединение прервано. Попытка повторного подключения...');
                setTimeout(initSocket, 1000);
            }
        };
    };

    // Start recording session with microphone access
    const startRecordingSession = () => {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                audioContext = new (window.AudioContext || window.webkitAudioContext)(); // Mobile compatibility
            } else {
                audioContext = new AudioContext();
            }
            audioContext = new AudioContext();
            analyser = audioContext.createAnalyser();
            microphone = audioContext.createMediaStreamSource(stream);
            microphone.connect(analyser);

            recorder = new Recorder(audioContext);
            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                // Ensure the user gesture is in place for mobile devices to allow audio context resume
                audioContext.resume().then(() => {
                    console.log('Audio context resumed for mobile device');
                });
            }
            recorder.init(stream);

            isTracking = true;
            checkVolumeToStartRecording();
        });
    };

    // Check volume level to determine whether to start recording
    const checkVolumeToStartRecording = () => {
        if (!isTracking) {
            requestAnimationFrame(checkVolumeToStartRecording);
            return;
        }

        const bufferLength = analyser.fftSize;
        const dataArray = new Uint8Array(bufferLength);
        analyser.getByteTimeDomainData(dataArray);

        let sum = 0;
        for (let i = 0; i < bufferLength; i++) {
            sum += Math.abs(dataArray[i] - 128);
        }

        const average = sum / bufferLength;

        // Start recording if the noise level is above a certain threshold
        if (average > 10 && !isRecording) {
            startRecording();
        }

        // Stop recording after 2 seconds of silence
        if (isRecording && average < 5) {
            if (!silenceTimeout) {
                silenceTimeout = setTimeout(() => {
                    $('#loader').text('Ожидаем ответ пациента');
                    stopRecording();
                }, 2000);
            }
        } else if (isRecording && average > 5) {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
        }

        requestAnimationFrame(checkVolumeToStartRecording);
    };

    // Start recording audio
    const startRecording = () => {
        isRecording = true;
        recorder.start().then(() => {
            $('#loader').text('Говорите');
            console.log('Запись началась');
            // Send recorded audio chunks every second
            recordingInterval = setInterval(() => {
                sendRecordingChunk();
            }, 1000);
        }).catch(err => {
            console.error('Ошибка при запуске записи', err);
        });
    };

    // Send a chunk of recorded audio
    const sendRecordingChunk = () => {
        if (!isRecording) return;
        recorder.stop().then(({ blob }) => {
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.send(blob);
            } else {
                console.error('WebSocket соединение не открыто');
            }
            recorder.start();
        }).catch(err => {
            console.error('Ошибка при отправке фрагмента записи', err);
        });
    };

    // Stop recording audio
    const stopRecording = () => {
        isTracking = false;
        isRecording = false;

        clearInterval(recordingInterval);
        recorder.stop().then(({ blob }) => {
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.send(blob);
            }
            sendTextToServer();
        }).catch(err => {
            console.error('Ошибка при остановке записи', err);
            sendTextToServer();
        });
    };

    // Send recorded text to the server for processing
    const sendTextToServer = () => {
        let formData = new FormData();
        formData.append('text', text);

        $.ajax({
            url: '/ii-call/training/recognition',
            type: 'POST',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(response) {
                console.log('Аудио успешно отправлено!', response);

                // Play the response audio if provided
                if (response.audioUrl) {
                    const audio = new Audio(response.audioUrl);
                    audio.play();
                    $('#loader').text('Слушаем пациента');

                    audio.addEventListener('ended', () => {
                        isTracking = true;
                        if (!isRecording) {
                            startRecording();
                        }
                    });
                } else {
                    retryCount = 0;
                    isTracking = true;
                    startRecording();
                }

                // Update the dialogue in the UI
                if (response.dialog && Array.isArray(response.dialog)) {
                    const dialogContainer = $('#dialog');
                    dialogContainer.empty();
                    response.dialog.forEach(item => {
                        const messageElement = `<p class="${item.role}"><strong>${item.role}:</strong> ${item.content}</p>`;
                        dialogContainer.append(messageElement);
                    });
                }

                text = '';
            },
            error: function(error) {
                console.error('Ошибка отправки аудио', error);

                if (retryCount < maxRetries) {
                    retryCount++;
                    $.ajax(this);
                } else {
                    isTracking = true;
                }
            }
        });
    };

    // Stop tracking voice
    const stopTracking = () => {
        isTracking = false;
        isRecording = false;
        clearInterval(recordingInterval);
        if (silenceTimeout) {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
        }
        console.log('Отслеживание завершено');
    };

    // Clear the dialogue on the server and UI
    const clearDialogue = () => {
        $.ajax({
            url: '/ii-call/training/clear',
            type: 'POST',
            success: function(response) {
                $('#count-training').text("Осталось " + response.countTraining + " тренировок")
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#clear-training').prop('disabled', true)
                }
                $('#dialog').empty();
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });
    };

    const handleStartTraining = () => {

        if (!isDialog) {
            $.ajax({
                url: '/ii-call/training/init',
                type: 'POST',
                success: function(response) {
                    $('#count-training').text("Осталось " + response.countTraining + " тренировок")
                    if (response.dialog && Array.isArray(response.dialog)) {
                        const dialogContainer = $('#dialog');
                        dialogContainer.empty();
                        response.dialog.forEach(item => {
                            const messageElement = `<p class="${item.role}"><strong>${item.role}:</strong> ${item.content}</p>`;
                            dialogContainer.append(messageElement);
                        });
                    }

                    // Create a WebSocket connection and start the recording session
                    initSocket();
                    startRecordingSession();

                    $('#start-training').text('Продолжить тренировку').prop('disabled', true)
                    $('#stop-training').prop('disabled', false)
                    $('#save-training').show().prop('disabled', false)
                    $('#save-start-training').show().prop('disabled', false)

                    isDialog = true;
                },
                error: function(error) {
                    console.error('Ошибка начала диалога', error);
                }
            });
        } else {
            // Create a WebSocket connection and start the recording session
            initSocket();
            startRecordingSession();

            $('#start-training').text('Продолжить тренировку').prop('disabled', true)
            $('#stop-training').prop('disabled', false)
            $('#save-training').show().prop('disabled', false)
            $('#save-start-training').show().prop('disabled', false)
        }


    }

    const handleStopTraining = () => {
        // Stop tracking voice and close the WebSocket connection
        stopTracking();
        if (socket) {
            socket.close();
        }
        $('#loader').text('Запись остановлена');
        $('#start-training').prop('disabled', false)
        $('#stop-training').prop('disabled', true)
    }

    const handleSaveTraining = () => {
        stopTracking();
        if (socket) {
            socket.close();
        }
        $('#loader').text('Запись остановлена');

        $.ajax({
            url: '/ii-call/training/save',
            type: 'POST',
            success: function(response) {
                $('#count-training').text("Осталось " + response.countTraining + " тренировок")
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#clear-training').prop('disabled', true)
                }
                $('#dialog').empty();
                isDialog = false
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });

        $('#start-training').text('Начать тренировку').prop('disabled', false)
        $('#stop-training').prop('disabled', true)
        $('#save-training').hide()
        $('#save-start-training').hide()

    };

    const handleSaveStartTraining = () => {
        $.ajax({
            url: '/ii-call/training/clear',
            type: 'POST',
            success: function(response) {
                $('#count-training').text("Осталось " + response.countTraining + " тренировок")
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#save-training').hide()
                    $('#save-start-training').hide()
                }
                $('#dialog').empty();

                isDialog = false;
                if (response.countTraining > 0) {
                    handleStartTraining();
                }
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });
    }

    init();
};
